<template>
  <a @click="$emit('click')" class="btn btn-atendimento">
    <i class="fa fa-headphones m-r"></i> Iniciar Atendimento
  </a>
</template>

<script>
export default {
  name: 'BtnAtendimento'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// BtnAtendimento.vue?0456c728